module.exports = __webpack_public_path__ + "9f374793bb4293e0ac25723e37dc2d69.svg";